import QueryString from 'qs';

export interface ISortQuery {
  sortField?: string;
  sortOrder?: 'asc' | 'desc';
}

export const convertSortQueryStringToSortQuery = ({
  sortField,
  sortOrder,
}: QueryString.ParsedQs): Partial<ISortQuery> => ({
  sortField: typeof sortField === 'string' ? sortField : undefined,
  sortOrder: sortOrder === 'asc' || sortOrder === 'desc' ? sortOrder : undefined,
});
